'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withSpacing = require('../withSpacing');

var _withSpacing2 = _interopRequireDefault(_withSpacing);

var _Heading = require('../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _LoadingIndicator = require('../LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = {
  'screen-small': '(max-width: 539px)',
  'screen-gt-small': '(min-width: 540px)',
  'screen-medium': '(max-width: 959px)',
  'screen-gt-medium': '(min-width: 960px)',
  'screen-large': '(max-width: 1247px)',
  'screen-gt-large': '(min-width: 1248px)',
  'screen-x-large': '(max-width: 1919px)',
  'screen-gt-x-large': '(min-width: 1920px)',
  'card': 'tcl__Card-76274da4',
  'withoutPadding': 'tcl__Card-875b2787',
  'loadingIndicator': 'tcl__Card-162711d2'
};

/**
 * Card component for use in page layouts.
 */

var Card = function Card(_ref) {
  var className = _ref.className,
      title = _ref.title,
      hasPadding = _ref.hasPadding,
      isLoading = _ref.isLoading,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['className', 'title', 'hasPadding', 'isLoading', 'children']);

  return _react2.default.createElement(
    'div',
    _extends({
      className: (0, _classnames2.default)(styles.card, !hasPadding && styles.withoutPadding, className)
    }, props),
    title && _react2.default.createElement(
      _Heading2.default,
      { level: 2, size: 'small', spacing: '0 0 medium 0' },
      title
    ),
    isLoading && _react2.default.createElement(_LoadingIndicator2.default, { className: styles.loadingIndicator }),
    children
  );
};

Card.displayName = 'Card';
Card.propTypes = _extends({}, _withSpacing.propTypes, {

  /**
   * The contents of your card.
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * Any additional css classes.
   */
  className: _propTypes2.default.string,

  /**
   * If truthy, will show a loading indicator in the top right of the card.
   */
  isLoading: _propTypes2.default.bool,

  /**
   * If truthy, will render without edge padding. This is useful when you want to specify
   * your own padding and opt out of the default padding cards have per screen size.
   */
  hasPadding: _propTypes2.default.bool,

  /**
   * If provided will render a title for the card for you and add some spacing from the content.
   */
  title: _propTypes2.default.string
});

Card.defaultProps = {
  isLoading: false,
  title: '',
  className: '',
  hasPadding: true
};

exports.default = (0, _withSpacing2.default)(Card);